import React, { useState } from 'react';
import { Button, Container, Form, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faLocationDot } from '@fortawesome/free-solid-svg-icons';

const KdeNasNajdete = () => {
    const [showCopySuccess, setShowCopySuccess] = useState(false); // Stav pro řízení zobrazení zprávy
    const adresa = "Mládežnická 422, Neratovice"; // Adresa

    const handleCopy = () => {
        navigator.clipboard.writeText(adresa).then(() => {
            setShowCopySuccess(true); // Zobrazit zprávu
            setTimeout(() => {
                setShowCopySuccess(false); // Skrýt zprávu po 3 vteřinách
            }, 3000);
        }, (err) => {
            console.error('Nelze zkopírovat text: ', err);
        });
    };

    return (
        <div className='d-flex flex-column text-center w-100'>
            <header>
                <h2><FontAwesomeIcon icon={faLocationDot} />&nbsp;Kde nás najdete?</h2>
            </header>
            <div className='h-100 w-100'>
                <Container className='h-100'>
                    <Row className='justify-content-center h-100'>
                        <Col lg="8" className='align-self-center d-flex flex-column'>

                            <div className='mb-3'>
                                <div className="input-group">
                                    <Form.Control
                                        type="text"
                                        value={adresa}
                                        readOnly
                                    />
                                    <Button variant='outline-secondary' onClick={handleCopy}>
                                        <FontAwesomeIcon icon={faCopy} />
                                    </Button>
                                </div>
                                {showCopySuccess && (
                                    <Form.Text id="copyHelpBlock" muted>
                                        Adresa zkopírována do schránky.
                                    </Form.Text>
                                )}

                            </div>

                            <div>
                                <a href="https://mapy.cz/s/nodukocafo" target="_blank" rel="noreferrer">Mapy.cz</a>
                            </div>

                            <div>
                                <a href="https://maps.app.goo.gl/5fSSdDsTgarQgAe8A" target="_blank" rel="noreferrer">Google Maps</a>
                            </div>

                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
};

export default KdeNasNajdete;
